import PageGenerator from './PageGenerator.vue'

// 安装函数
const install = function(Vue) {
  if (install.installed) return
  install.installed = true
  // 注册表单生成器组件
  Vue.component(PageGenerator.name, PageGenerator)
}

// 自动安装
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
  PageGenerator,
}
export { PageGenerator }